import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { DialogProps } from "../../../../@types/dialogProps.types";
import TabPanel from "../../../shared/tabPanelComponent/TabPanel";
import a11yProps from "../../../../constants/tabPanelProps/ayProps";
import { AuthContext, UIContext } from "../../../../contexts";
import { LazyCustomDialog } from "../../../shared";
import { ADMIN_DASHBOARD_HEADER } from "../../../../constants/caption/dashboardHeader";
import { api } from "../../../../utils/api";
// import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
// import { AgGridColumn, AgGridReact } from "ag-grid-react";
import GroupAllLocationsGrid from "./groupAllLocationsGrid/GroupAllLocationsGrid";

import { Pagination } from "@material-ui/lab";
import { Button, Tab, Tabs, Typography, Box } from "@material-ui/core";
import PropTypes from "prop-types";

import AddIcon from "@material-ui/icons/Add";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./allLocation.css";
import LocationGrid from "./locationGrid/LocationGrid";
import useRouteParam from "../../../../hooks/useRouteParam";
import { trackPromise } from "react-promise-tracker";
import { useEnroller } from "../../../../hooks";
import CircularLoader from "../../../shared/loader/CircularLoader";
import { getPermissionsFromGroupOwner } from "../../../../utils/getPermissionsFromGroupOwner";

// eslint-disable-next-line arrow-parens
// eslint-disable-next-line arrow-parens
// const TabPanel = (props: any) => {
// 	const { children, value, index, ...other } = props;

// 	return (
// 		<div
// 			role="tabpanel"
// 			hidden={value !== index}
// 			id={`simple-tabpanel-${index}`}
// 			aria-labelledby={`simple-tab-${index}`}
// 			{...other}
// 		>
// 			{value === index && (
// 				<Box sx={{ p: 3 }}>
// 					<Typography>{children}</Typography>
// 				</Box>
// 			)}
// 		</div>
// 	);
// };

// TabPanel.propTypes = {
// 	children: PropTypes.node,
// 	index: PropTypes.number.isRequired,
// 	value: PropTypes.number.isRequired
// };

// eslint-disable-next-line prettier/prettier
// eslint-disable-next-line arrow-parens
// const a11yProps = (index: number) => {
// 	return {
// 		id: `simple-tab-${index}`,
// 		"aria-controls": `simple-tabpanel-${index}`
// 	};
// };

const Locations = () => {
	const [locationData, setLocationData] = useState([]);
	const { isEnroller } = useEnroller();
	const [value, setValue] = useState<number>(0);
	const [groupNumber, setGroupNumber] = useState<number | null>(null);
	const queryGroupNumber = useRouteParam("gn");
	const [loading, setLoading] = useState(true);
	const [locationDialogProps, setLocationDialogProps] = useState<DialogProps>({
		openDialog: false,
		title: "Are you sure you want to disable the location?",
		content: "Then move employees to other location ?",
		actions: [
			{
				label: "Cancel",
				callback: () => {
					setLocationDialogProps(Object.assign({}, locationDialogProps, { openDialog: false }));
				}
			},
			{
				label: "Move Employees",
				callback: () => null
			}
		]
	});
	const navigate = useNavigate();
	const { setDashboardHeader } = useContext(UIContext);

	const { user, setUser } = useContext(AuthContext);

	const groupLocationsPermission = user
		? getPermissionsFromGroupOwner(user, Number(queryGroupNumber))?.locations_menu.self
		: null;

	const handleAddLocationPageChange = useCallback(() => {
		navigate(`/employer/locations/add-location?gn=${queryGroupNumber}`);
	}, [navigate, queryGroupNumber]);

	// const handleLabelChange = (event: React.ChangeEvent<unknown>, value: number) => {
	// 	setValue(value);
	// };

	const getGroupSpecificAllLocations = useCallback(async (group_number: number | null | undefined) => {
		setLoading(true);
		try {
			const response = await trackPromise(api.group.getGroupSpecificAllLocations(group_number));
			// console.log("Group Location Data", response);
			if (response) {
				setLocationData(Object.assign([], response));
			}
		} catch (error) {
			console.log("Console Error", error);
		} finally {
			setLoading(false);
		}

		// const _disabledLocData = _locations.filter((eachLoc: any) => {
		// 	return eachLoc.location_status === "Disabled";
		// });
		// const _activeLocations = _locations.filter((eachLoc: any) => {
		// 	return eachLoc.location_status === "Active";
		// });
		// setActiveLocations(Object.assign([], _activeLocations));
		// setDisabledLocData(Object.assign([], _disabledLocData));
	}, []);

	// const disabledLocData = locations.filter((eachLoc: any) => {
	// 	return eachLoc.location_status === "Disabled";
	// });
	// console.log("Each Loc", disabledLocData);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.all_locations);
	}, [setDashboardHeader]);

	useEffect(() => {
		if (queryGroupNumber) getGroupSpecificAllLocations(queryGroupNumber as number);

		// setGroupNumber(220);
	}, [getGroupSpecificAllLocations, queryGroupNumber]);

	// console.log(locationData);

	// if (!groupNumber) return <></>;
	return (
		<div className="all-location-container">
			{/* <Suspense fallback={<div />}>
				<LazyCustomDialog dialogProps={locationDialogProps} />
			</Suspense> */}
			{groupLocationsPermission && groupLocationsPermission.create ? (
				<div className="pf-action-button-container" id="pf-action-button-container">
					<Button className="button-green" variant="contained" onClick={handleAddLocationPageChange}>
						<span className="button-label-with-icon">Add Location</span>
						<span>
							<AddIcon className="button-icon" />
						</span>
					</Button>
				</div>
			) : null}
			<div className="all-location-tab-container">
				{loading && <CircularLoader />}
				{groupLocationsPermission && groupLocationsPermission.view && (
					<GroupAllLocationsGrid locationData={locationData} />
				)}
				{/* <Box sx={{ width: "100%" }}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<Tabs
							value={value}
							onChange={handleLabelChange}
							aria-label="basic tabs example"
							TabIndicatorProps={{
								style: {
									border: "none",
									backgroundColor: "#558b2f"
								}
							}}
							className="glb-tab-panel"
						>
							<Tab label={"Active Location"} className="glb-tab-label" {...a11yProps(0)} />
							<Tab label={"Disabled Location"} className="glb-tab-label" {...a11yProps(1)} />
						</Tabs>
					</Box>
					<TabPanel value={value} index={0}>
						<LocationGrid gridProps={activeLocations} groupNumber={groupNumber} tabLabel={"active"} />
					</TabPanel>
					<TabPanel value={value} index={1}>
						<LocationGrid gridProps={disabledLocData} groupNumber={groupNumber} tabLabel={"disabled"} />
					</TabPanel>
				</Box> */}
			</div>
		</div>
	);
};

export default Locations;
